module.exports = __webpack_public_path__ + "img/gerenaihaozhe.52722e8e.png";